export default __webpack_public_path__ + "static/media/cannes-1x.0a90d677.webp";